import React from 'react';
import { IProps } from './type';

const VisibilityIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5405 12.8848C20.5405 12.526 20.3465 12.2903 19.9583 11.8191C18.5382 10.0949 15.406 6.88477 11.7703 6.88477C8.13454 6.88477 5.00233 10.0949 3.58224 11.8191C3.19408 12.2903 3 12.526 3 12.8848C3 13.2436 3.19408 13.4792 3.58224 13.9505C5.00233 15.6746 8.13454 18.8848 11.7703 18.8848C15.406 18.8848 18.5382 15.6746 19.9583 13.9505C20.3465 13.4792 20.5405 13.2436 20.5405 12.8848ZM11.7703 15.8848C13.4271 15.8848 14.7703 14.5416 14.7703 12.8848C14.7703 11.2279 13.4271 9.88477 11.7703 9.88477C10.1134 9.88477 8.77028 11.2279 8.77028 12.8848C8.77028 14.5416 10.1134 15.8848 11.7703 15.8848Z"
        fill={fillColor ? fillColor : "#1C232C"}
        fillOpacity="0.44" />
    </svg>
  )
};

export default VisibilityIcon;
